import { render, staticRenderFns } from "./GithubImgStorageModal.vue?vue&type=template&id=2a458ed0&"
import script from "./GithubImgStorageModal.vue?vue&type=script&lang=js&"
export * from "./GithubImgStorageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubImgStorageModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GithubImgStorageModal.vue
// module id = 2364
// module chunks = 1